
import Vue from 'vue';

export default Vue.extend({
	name: 'StaticBenefitLineItem',
	props: {
		icon: { type: String, default: null },
		disabledBenefit: { type: Boolean, default: false },
	},
});
